import "./ProjectPage2.module.css";
import Header from "@/reusable_sections/Header";
import OurStory from "./sections/OurStory";
import LaminateDetails from "./sections/LaminateDetails";
import ProjectsOverview from "./sections/ProjectsOverview";
import Footer from "@/reusable_sections/Footer";
export default function ProjectPage2() {
  return <div>
      <Header />
      <OurStory />
      <LaminateDetails />
      <ProjectsOverview />
      <Footer />
    </div>;
}